import { ArticleFilledIcon, Breakpoint, Button, HeadingXL, IconSize } from "@enxcs/dap-ui-stratos";
import { FC } from "react";
import { RecordingListNoResultContainer } from "./RecordingListNoResult.styles";
import { useTranslation } from "react-i18next";

interface RecordingListNoResultProps {
  handleTriggerNewRecordingModal: () => void;
}

const RecordingListNoResult: FC<RecordingListNoResultProps> = ({
  handleTriggerNewRecordingModal,
}) => {
  const { t } = useTranslation();


  return (
    <RecordingListNoResultContainer
      data-testid="no-result-container"
      $justify="center"
      $align="center"
      $breakpoint={Breakpoint.M}
      $grow
    >
      <ArticleFilledIcon size={IconSize.V80} />

      <HeadingXL className="primaryMessage">{t("recordsLibrary.noResultTitle")}</HeadingXL>

      <Button
        label={t("recordsLibrary.noResultButtonLabel")}
        onClick={handleTriggerNewRecordingModal}
      />
    </RecordingListNoResultContainer>
  );
};

export default RecordingListNoResult;
